import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Fade } from "react-reveal";
import {
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Steper from "Component/Steper/Steper";
import Selecttokenmod from "Component/Modals/Selecttokenmod";
import { useDispatch, useSelector } from "react-redux";
import Loader from "Component/Common/Loader";
import { resetPassword } from "store/actions";

import { useNavigate, useLocation } from "react-router-dom";
import useToastr from "helpers/toastr";
import { useTranslation } from "react-i18next";
import Header from "Component/Header/Header";
import Footer from "Component/Footer/Footer";

const ResetPassword = (props) => {
  const { loading } = useSelector((state) => state?.VerifyEmail);
  const location = useLocation();
  const [passwordTypeConfirm, setConfirmPasswordType] = useState("password");
  const [passwordTypeNew, setNewPasswordType] = useState("password");
  const { t } = useTranslation();

  const urlParams = new URLSearchParams(location.search);

  const token = urlParams.get("token");

  const navigate = useNavigate();
  const [selecttoken, setselectoken] = useState(false);
  const dispatch = useDispatch();
  const toastr = useToastr();
  /**
   * Used for initialise the state first time
   */
  const [fields, setFields] = useState({
    new_password: "",
    confirm_password: "",
    token: token,
  });

  const handleback = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  /**
   * Used for control the input states
   */
  const handleChange = (name) => (e) => {
    setFields((prev) => ({ ...prev, [name]: e.target.value }));
  };
  const toggleConfirmPassword = () => {
    if (passwordTypeConfirm === "password") {
      setConfirmPasswordType("text");
      return;
    }
    setConfirmPasswordType("password");
  };

  const toggleNewPassword = () => {
    if (passwordTypeNew === "password") {
      setNewPasswordType("text");
      return;
    }
    setNewPasswordType("password");
  };

  /**
   * Used for save the password to the backend
   */
  const handleVerify = (e) => {
    e.preventDefault();
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={}[\]:;<>,.?~\\-])(?=.{8,})/;

    if (fields.new_password == "" || fields.confirm_password == "") {
      return toastr.error(t("all_fields_required"));
    }

    const isValidPassword = passwordRegex.test(fields.new_password);
    if (!isValidPassword) {
      return toastr.error(t("password_error"));
    }

    if (fields.new_password !== fields.confirm_password) {
      return toastr.error(t("password_not_match"));
    }

    const callback = (response) => {
      if (response.statusCode == "200") {
        toastr.success(t("password_reset"));
        navigate("/signin");
      } else {
        toastr.error(response.message);
      }
    };
    dispatch(resetPassword(fields, callback));
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 32) {
      e.preventDefault();
    }
  };
  /**
   * Used for render the UI forgot password
   */

  return (
    <div>
      <Header />
      <Fade>
        <Selecttokenmod
          show={selecttoken}
          onHide={() => setselectoken(false)}
        />

        <section
          className="terms-of-service home_banner_main buy_page position-relative text-start"
          // style={{ paddingTop: "120px" }}
        >
          {loading && <Loader />}

          <div className="top_circle"></div>

          <Container fluid className="position-relative container_postition">
            <Row>
              <Col lg={6} md={12} sm={12} className="m-auto">
                <div className="common_box_wrap pt-0">
                  <div className="trassaction_mod_inner position-relative text-start">
                    <div className="d-flex align-items-center">
                      <a
                        href="javascript:void(0)"
                        className="arrow-back d-flex align-items-center gap-2"
                        onClick={handleback}
                      >
                        <span className="me-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 40 30"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_48_5634)">
                              <path
                                d="M3.23437 13.2344C2.25781 14.2109 2.25781 15.7969 3.23437 16.7734L15.7344 29.2734C16.7109 30.25 18.2969 30.25 19.2734 29.2734C20.25 28.2969 20.25 26.7109 19.2734 25.7344L11.0312 17.5L35 17.5C36.3828 17.5 37.5 16.3828 37.5 15C37.5 13.6172 36.3828 12.5 35 12.5L11.0312 12.5L19.2656 4.26562C20.2422 3.28906 20.2422 1.70312 19.2656 0.72656C18.2891 -0.250003 16.7031 -0.250003 15.7266 0.72656L3.22656 13.2266L3.23437 13.2344Z"
                                fill="black"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_48_5634">
                                <rect
                                  width="30"
                                  height="40"
                                  fill="white"
                                  transform="translate(0 30) rotate(-90)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </a>
                      <h4 className="m-0">{t("reset_password")}</h4>
                    </div>

                    <div className="email_form-main my-4">
                      <Form className="email_form">
                        <FormGroup className="position-relative">
                          <Label for="exampleEmail">
                            {t("new_password")}{" "}
                            <span className="col_red">
                              <sup>*</sup>
                            </span>
                          </Label>
                          <Input
                            type={passwordTypeNew}
                            name="new_password"
                            id="examplePassword"
                            placeholder="........."
                            onChange={handleChange("new_password")}
                            onKeyDown={handleKeyDown}
                            title={t("fill_this_field")}
                          />
                          {passwordTypeNew === "password" ? (
                            <Button
                              className="eye_btn"
                              onClick={toggleNewPassword}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 256 256"
                              >
                                <path
                                  fill="#9BA1B3"
                                  d="M53.92 34.62a8 8 0 1 0-11.84 10.76l19.24 21.17C25 88.84 9.38 123.2 8.69 124.76a8 8 0 0 0 0 6.5c.35.79 8.82 19.57 27.65 38.4C61.43 194.74 93.12 208 128 208a127.11 127.11 0 0 0 52.07-10.83l22 24.21a8 8 0 1 0 11.84-10.76Zm47.33 75.84l41.67 45.85a32 32 0 0 1-41.67-45.85M128 192c-30.78 0-57.67-11.19-79.93-33.25A133.16 133.16 0 0 1 25 128c4.69-8.79 19.66-33.39 47.35-49.38l18 19.75a48 48 0 0 0 63.66 70l14.73 16.2A112 112 0 0 1 128 192m6-95.43a8 8 0 0 1 3-15.72a48.16 48.16 0 0 1 38.77 42.64a8 8 0 0 1-7.22 8.71a6.39 6.39 0 0 1-.75 0a8 8 0 0 1-8-7.26A32.09 32.09 0 0 0 134 96.57m113.28 34.69c-.42.94-10.55 23.37-33.36 43.8a8 8 0 1 1-10.67-11.92a132.77 132.77 0 0 0 27.8-35.14a133.15 133.15 0 0 0-23.12-30.77C185.67 75.19 158.78 64 128 64a118.37 118.37 0 0 0-19.36 1.57A8 8 0 1 1 106 49.79A134 134 0 0 1 128 48c34.88 0 66.57 13.26 91.66 38.35c18.83 18.83 27.3 37.62 27.65 38.41a8 8 0 0 1 0 6.5Z"
                                />
                              </svg>
                            </Button>
                          ) : (
                            <Button
                              className="eye_btn"
                              onClick={toggleNewPassword}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 256 256"
                              >
                                <path
                                  fill="#9BA1B3"
                                  d="M245.48 125.57c-.34-.78-8.66-19.23-27.24-37.81C201 70.54 171.38 50 128 50S55 70.54 37.76 87.76c-18.58 18.58-26.9 37-27.24 37.81a6 6 0 0 0 0 4.88c.34.77 8.66 19.22 27.24 37.8C55 185.47 84.62 206 128 206s73-20.53 90.24-37.75c18.58-18.58 26.9-37 27.24-37.8a6 6 0 0 0 0-4.88M128 194c-31.38 0-58.78-11.42-81.45-33.93A134.77 134.77 0 0 1 22.69 128a134.56 134.56 0 0 1 23.86-32.06C69.22 73.42 96.62 62 128 62s58.78 11.42 81.45 33.94A134.56 134.56 0 0 1 233.31 128C226.94 140.21 195 194 128 194m0-112a46 46 0 1 0 46 46a46.06 46.06 0 0 0-46-46m0 80a34 34 0 1 1 34-34a34 34 0 0 1-34 34"
                                />
                              </svg>
                            </Button>
                          )}
                        </FormGroup>
                        <FormGroup className="position-relative">
                          <Label for="exampleEmail">
                            {t("confirm_password")}{" "}
                            <span className="col_red">
                              <sup>*</sup>
                            </span>
                          </Label>
                          <Input
                            type={passwordTypeConfirm}
                            name="confirm_password"
                            id="examplePassword"
                            placeholder="........."
                            onChange={handleChange("confirm_password")}
                            onKeyDown={handleKeyDown}
                            title={t("fill_this_field")}
                          />

                          {passwordTypeConfirm === "password" ? (
                            <Button
                              className="eye_btn"
                              onClick={toggleConfirmPassword}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 256 256"
                              >
                                <path
                                  fill="#9BA1B3"
                                  d="M53.92 34.62a8 8 0 1 0-11.84 10.76l19.24 21.17C25 88.84 9.38 123.2 8.69 124.76a8 8 0 0 0 0 6.5c.35.79 8.82 19.57 27.65 38.4C61.43 194.74 93.12 208 128 208a127.11 127.11 0 0 0 52.07-10.83l22 24.21a8 8 0 1 0 11.84-10.76Zm47.33 75.84l41.67 45.85a32 32 0 0 1-41.67-45.85M128 192c-30.78 0-57.67-11.19-79.93-33.25A133.16 133.16 0 0 1 25 128c4.69-8.79 19.66-33.39 47.35-49.38l18 19.75a48 48 0 0 0 63.66 70l14.73 16.2A112 112 0 0 1 128 192m6-95.43a8 8 0 0 1 3-15.72a48.16 48.16 0 0 1 38.77 42.64a8 8 0 0 1-7.22 8.71a6.39 6.39 0 0 1-.75 0a8 8 0 0 1-8-7.26A32.09 32.09 0 0 0 134 96.57m113.28 34.69c-.42.94-10.55 23.37-33.36 43.8a8 8 0 1 1-10.67-11.92a132.77 132.77 0 0 0 27.8-35.14a133.15 133.15 0 0 0-23.12-30.77C185.67 75.19 158.78 64 128 64a118.37 118.37 0 0 0-19.36 1.57A8 8 0 1 1 106 49.79A134 134 0 0 1 128 48c34.88 0 66.57 13.26 91.66 38.35c18.83 18.83 27.3 37.62 27.65 38.41a8 8 0 0 1 0 6.5Z"
                                />
                              </svg>
                            </Button>
                          ) : (
                            <Button
                              className="eye_btn"
                              onClick={toggleConfirmPassword}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 256 256"
                              >
                                <path
                                  fill="#9BA1B3"
                                  d="M245.48 125.57c-.34-.78-8.66-19.23-27.24-37.81C201 70.54 171.38 50 128 50S55 70.54 37.76 87.76c-18.58 18.58-26.9 37-27.24 37.81a6 6 0 0 0 0 4.88c.34.77 8.66 19.22 27.24 37.8C55 185.47 84.62 206 128 206s73-20.53 90.24-37.75c18.58-18.58 26.9-37 27.24-37.8a6 6 0 0 0 0-4.88M128 194c-31.38 0-58.78-11.42-81.45-33.93A134.77 134.77 0 0 1 22.69 128a134.56 134.56 0 0 1 23.86-32.06C69.22 73.42 96.62 62 128 62s58.78 11.42 81.45 33.94A134.56 134.56 0 0 1 233.31 128C226.94 140.21 195 194 128 194m0-112a46 46 0 1 0 46 46a46.06 46.06 0 0 0-46-46m0 80a34 34 0 1 1 34-34a34 34 0 0 1-34 34"
                                />
                              </svg>
                            </Button>
                          )}
                        </FormGroup>
                        {/* <FormGroup check>
                        <Label check>
                          <Input type="checkbox" /> I agree with{" "}
                          <a
                            href="https://transak.com/terms-of-service"
                            target="_blank"
                          >
                            Terms of Use
                          </a>{" "}
                          and {""}
                          <a
                            href="https://transak.com/privacy-policy"
                            target="_blank"
                          >
                            Privacy Policy
                          </a>
                        </Label>
                      </FormGroup> */}
                        <Button
                          className="btn_sign_in w-100 btn_theme mt-4"
                          onClick={handleVerify}
                        >
                          {t("continue")}
                        </Button>
                      </Form>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <div className="bottom_circle"></div>
        </section>
      </Fade>
      <Footer />
    </div>
  );  
};

export default ResetPassword;
